import React, {useEffect,useLayoutEffect,useRef, useState} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse, Slider} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsThemeListAction, fetchSetLikeAction, fetchTalesListAction, ROUTE_PATH, selectStore} from "../../utils";
import {MyText} from "../../components";
import {LeftOutlined, CaretRightOutlined, PauseOutlined, HeartOutlined, HeartFilled , ForwardOutlined, BackwardOutlined} from "@ant-design/icons";
import { PageName, ButtonContainer, StyledImageWrapper } from "./style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { PlayButtonContainer } from "./style";
import { Helmet } from "react-helmet";
import { MySegmented } from "../../components";
import { COOKIE_KEY } from "../../utils";
import { Cookies } from "react-cookie";

export const AudioTales = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const age = searchParams.get("age");
  // const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
  const cookies = new Cookies()
  const cardsThemeList = useSelector((state: any) => state.materials?.cardsThemeList ?? { data: null, loading: false });
  const setLike = useSelector((state: any) => state.materials?.setLike ?? { data: null });

  const topicIdFromParams = searchParams.get('topic_id');
  const segmentedParams: any = searchParams.get('type');
  const cardPageFromParams = Number(searchParams.get('card_page')) || 1;
  const hasScrolledToSelected = useRef(false);
  const [authors, setAuthors] = useState([]);
  const [articles, setArticles] = useState([]);
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
  const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
  const [themes, setThemes] = useState([]);
  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [duration, setDuration] = useState(0);
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [localLikes, setLocalLikes] = useState<Record<number, boolean>>({});
  const [page, setPage] = useState(cardPageFromParams);
  const [isLoading, setIsLoading] = useState(false);
  const [allCards, setAllCards] = useState<any[]>([]);

  const cardContainerRef = useRef<HTMLDivElement | null>(null);

  const prevScrollHeight = useRef(0);
  const loadDirection = useRef<'up' | 'down' | null>(null);

  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);


  const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };  

  // const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);

  // useEffect(() => {
  //     const fetchContent = async () => {
  //         try {
  //             const response = await fetchCardsThemeList();
  //             setThemes(response.categories || []);
  //         } catch (error) {
  //             console.error('Error fetching themes:', error);
  //         }
  //     };
  
  //     fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchCardsThemeListAction());
  }, []);

  useEffect(() => {
    if (!cardsThemeList.success || !cardsThemeList.data) return;
    setThemes(cardsThemeList.data.categories || []);
  }, [cardsThemeList.success, cardsThemeList.data]);

  const {materials: {talesList: talesListState}} = useSelector(selectStore)
  const pagination = talesListState?.data?.pagination;
const isRestoringScroll = useRef(false);

  // useEffect(() => {
    
  //     dispatch(fetchTalesListAction({
  //       // category: gameCategory,
  //       // fromAge,
  //       // toAge
  //     }))
    
  // }, [])

useEffect(() => {
  setAllCards([]);
  hasScrolledToSelected.current = false;
  const savedPage = Number(searchParams.get('card_page')) || 1;
  setPage(savedPage);
}, [segmentedParams]);

useEffect(() => {
  const fetchData = async () => {
    if (isLoading) return;

    setIsLoading(true);

    const params = {
      page,
      ...(segmentedParams === "favorites" && { likes: 1 }),
    };

    await dispatch(fetchTalesListAction(params));
    setIsLoading(false);
  };

  fetchData();
}, [page, segmentedParams]);

useEffect(() => {
  const cards = talesListState?.data?.cards || [];

  if (!cards.length) return;

  setAllCards(prev => {
    if (!prev.length) return cards.map(c => ({ ...c, page }));

    if (page > prev[prev.length - 1].page) {
      return [...prev, ...cards.map(c => ({ ...c, page }))];
    }

    if (page < prev[0].page) {
      return [...cards.map(c => ({ ...c, page })), ...prev];
    }

    return prev;
  });
}, [talesListState?.data?.cards]);

const anchorRef = useRef<HTMLElement | null>(null);

const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
  if (isRestoringScroll.current || isLoading || !pagination) return;

  const el = e.currentTarget;

  if (el.scrollTop <= 5 && page > 1) {
    loadDirection.current = 'up';

    const children = Array.from(el.children) as HTMLElement[];
    anchorRef.current = children.find(
      child => child.getBoundingClientRect().bottom > el.getBoundingClientRect().top
    ) || null;

    setPage(prev => prev - 1);
  }

  if (el.scrollHeight - el.scrollTop - el.clientHeight < 5 && page < pagination.page_count) {
    loadDirection.current = 'down';
    setPage(prev => prev + 1);
  }
};

 useLayoutEffect(() => {
  if (loadDirection.current === 'up' && anchorRef.current && cardContainerRef.current) {
    if (!hasScrolledToSelected.current) return;
    
    isRestoringScroll.current = true;
    anchorRef.current.scrollIntoView({ block: 'start' });
    requestAnimationFrame(() => {
      isRestoringScroll.current = false;
    });
  }
  loadDirection.current = null;
}, [allCards]);

  // useEffect(() => {
  //   if (talesListState?.data?.cards?.length && !selectedCard) {
  //     setSelectedCard(talesListState.data.cards[0]);
  //   }
  // }, [talesListState?.data?.cards, selectedCard]);
  

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');

  if (!topicIdFromParams) {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
    return;
  }

  const topicId = Number(topicIdFromParams);
  const matchedTheme = themes.find(theme => theme.id === topicId);

  if (matchedTheme) {
    setSelectedSubThemeId(topicId);
    setSelectedSubThemeName(matchedTheme.name);
    setSelectedParentTheme(matchedTheme);
  } else {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
  }
}, [themes, searchParams, t]);

  const handleThemesDataSubmit = (items: any[], totalCount: number) => {
  const type = searchParams.get('type');

  if (type === 'authors') {
    setAuthors(items);
    setTotalCount(totalCount);
  } else {
    setArticles(items);
    setTotalCount(totalCount);
  }
};

  const handleGoBack = () => {
    embeddedNavigate('/');
  }

    const togglePlay = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  };

// const handleTimeUpdate = () => {
//   if (audioRef.current) {
//     const { currentTime, duration } = audioRef.current;
//     setProgress((currentTime / duration) * 100);
//     setRemaining(duration - currentTime);
//   }
// };


const handleTimeUpdate = () => {
  const audio = audioRef.current;
  if (!audio) return;
  const { currentTime, duration: dur } = audio;
  if (!dur || isNaN(dur) || dur === 0) return;
  const prog = (currentTime / dur) * 100;
  setProgress(prog);
  setRemaining(dur - currentTime);
};

const getBaseIsLiked = (cardId: number) => {
  const cardFromList = talesListState?.data?.cards?.find((c: any) => c.id === cardId);
  if (cardFromList) return !!cardFromList.is_liked;
  if (selectedCard?.id === cardId) return !!selectedCard.is_liked;
  return false;
};

// const toggleLike = (cardId: number) => {
//   const base = getBaseIsLiked(cardId);
//   const current = cardId in localLikes ? localLikes[cardId] : base;
//   const newVal = !current;

//   setLocalLikes((prev) => ({ ...prev, [cardId]: newVal }));
//   if (selectedCard?.id === cardId) {
//     setSelectedCard((prev) => (prev ? { ...prev, is_liked: newVal } : prev));
//   }

  

//   fetchSetLike(cardId, "cards")
//     .then((res) => {
//       const serverVal = res?.data?.is_liked;
//       if (typeof serverVal === "boolean") {
//         setLocalLikes((prev) => ({ ...prev, [cardId]: serverVal }));
//         if (selectedCard?.id === cardId) {
//           setSelectedCard((prev) => (prev ? { ...prev, is_liked: serverVal } : prev));
//         }
//       }
//     })
//     .catch(() => {
//       setLocalLikes((prev) => {
//         const copy = { ...prev };
//         copy[cardId] = base;
//         return copy;
//       });
//       if (selectedCard?.id === cardId) {
//         setSelectedCard((prev) => (prev ? { ...prev, is_liked: base } : prev));
//       }
//     });
// };

const toggleLike = (cardId: number) => {
  const base = getBaseIsLiked(cardId);
  const current = cardId in localLikes ? localLikes[cardId] : base;
  const newVal = !current;

  setLocalLikes((prev) => ({ ...prev, [cardId]: newVal }));
  if (selectedCard?.id === cardId) {
    setSelectedCard((prev) => (prev ? { ...prev, is_liked: newVal } : prev));
  }

  dispatch(fetchSetLikeAction({ entity_id: cardId, entity_type: 'cards' }));
};

useEffect(() => {
  if (!setLike.success || !setLike.data) return;
  const serverVal = setLike.data?.is_liked;
  if (typeof serverVal === 'boolean') {
    setLocalLikes((prev) => ({ ...prev, [setLike.data.id]: serverVal }));
    if (selectedCard?.id === setLike.data.id) {
      setSelectedCard((prev) => (prev ? { ...prev, is_liked: serverVal } : prev));
    }
  }
}, [setLike.success, setLike.data]);


const isLikedForList = (card: any) =>
  card.id in localLikes ? localLikes[card.id] : !!card.is_liked;

const selectCard = (card: any) => {
  const params = new URLSearchParams(searchParams);
  params.set('topic_id', card.id);
  params.set('card_page', String(card.page));
  setSearchParams(params);
  setSelectedCard(card);
};

useEffect(() => {
  if (!talesListState?.data?.cards?.length) return;

  if (topicIdFromParams) {
    const cardToSelect = talesListState.data.cards.find(
      (c: any) => String(c.id) === topicIdFromParams
    );
    if (cardToSelect) {
      setSelectedCard(cardToSelect);
    }
    return;
  }

  if (!selectedCard) {
    setSelectedCard(talesListState.data.cards[0]);
  }
}, [talesListState?.data?.cards]);

useLayoutEffect(() => {
  if (!selectedCard || !cardContainerRef.current) return;
  if (hasScrolledToSelected.current) return;
  
  const el = cardContainerRef.current;
  const cardEl = el.querySelector(`[data-card-id="${selectedCard.id}"]`);
  
  if (cardEl) {
    cardEl.scrollIntoView({ block: 'center' });
    hasScrolledToSelected.current = true;
  }
}, [selectedCard?.id, allCards]);

const selectedIsLiked =
  selectedCard && (selectedCard.id in localLikes ? localLikes[selectedCard.id] : !!selectedCard.is_liked);

//  const toggleLike = (cardId: number) => {
//   setSelectedCard((prev) =>
//     prev ? { ...prev, is_liked: !prev.is_liked } : prev
//   );

//   if (talesListState?.data?.cards) {
//     const updatedCards = talesListState.data.cards.map((card: any) =>
//       card.id === cardId ? { ...card, is_liked: !card.is_liked } : card
//     );

    
//   }

//   fetchSetLike(cardId, "cards");
// };

const formatTime = (seconds: number) => {
  if (!seconds || isNaN(seconds)) return "00:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
};

  const handleSliderChange = (value: number) => {
    if (audioRef.current) {
      audioRef.current.currentTime =
        (value / 100) * audioRef.current.duration;
      setProgress(value);
    }
  };


 const SPECIALIST_TYPE = [
  {
    key: 'allTales',
    title: t("allTales"),
  },
  ...(token
    ? [
        {
          key: 'favorites',
          title: t("favorites"),
        },
      ]
    : []),
];

const handleCardClick = (e: React.MouseEvent<HTMLDivElement>) => {
  const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const ratio = Math.max(0, Math.min(1, clickX / rect.width));
  const newProgress = ratio * 100;
  setProgress(newProgress);

  const audio = audioRef.current;
  const dur = (audio && audio.duration && !isNaN(audio.duration)) ? audio.duration : duration;
  if (audio && dur && !isNaN(dur) && dur > 0) {
    audio.currentTime = dur * ratio; 
  }
};

  const handleChangeSegmented = (value: any) => {
  const existingParams = Object.fromEntries(searchParams.entries());

  const newParams: Record<string, string> = {
    ...existingParams,
    type: value,
  };

  if (selectedSubThemeId !== null) {
  } else {
    delete newParams.topic_id;
  }

  setSearchParams(newParams);

};

useEffect(() => {
  if (selectedCard && playing && audioRef.current) {
    audioRef.current.play();
  }
}, [selectedCard, playing]);


  useEffect(() => {
    if (!segmentedParams) {
      handleChangeSegmented(SPECIALIST_TYPE[0].key);
    }
  }, [searchParams]);

  const parentThemesButton = themes;

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


      <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 24}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("audioTales")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {t("audioTales")}
                </MyText>
              </>
            )}
        </Row>
        <Row gutter={32}>
        <Col span={24}>
        {token && (
        <MySegmented
              type="primary"
              options={SPECIALIST_TYPE.map(item => ({
                label: item.title,
                value: item.key
              }))}
              style={{marginBottom: 24}}
              onChange={handleChangeSegmented}
              value={segmentedParams}
            />
        )}
        
            <Row gutter={20}>

              <Col
                xs={24}
                sm={talesListState?.data?.cards?.length ? 12 : 24}
                md={talesListState?.data?.cards?.length ? 12 : 24}
                lg={talesListState?.data?.cards?.length ? 12 : 24}
                xl={talesListState?.data?.cards?.length ? 12 : 24}
              >
        <Card ref={cardContainerRef} onScroll={handleScroll} style={{borderRadius: '20px', height: screens.xs ? '100%' : '650px',maxHeight: screens.xs ? 'calc(100vh - 100px)' : '650px', overflowY: 'auto',  scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
          <Spin spinning={talesListState?.loading}>
            <Row gutter={[24, 24]}>
            {/* {talesListState?.data?.cards?.length ? (
                talesListState.data.cards.map((oneGame: any) => ( */}
            {allCards.length ? (
                allCards.map((oneGame: any) => (
                  <>
                  <Col
                    key={oneGame.id + "-game-category"}
                    span={24}
                    data-card-id={oneGame.id}
                    onClick={() => selectCard(oneGame)}
                    ref={(el) => {
                    if (
                      loadDirection.current === 'up' &&
                      !anchorRef.current &&
                      el &&
                      cardContainerRef.current &&
                      el.getBoundingClientRect().bottom >
                        cardContainerRef.current.getBoundingClientRect().top
                    ) {
                      anchorRef.current = el;
                    }
                  }}

                  >
                    <Card
                      bordered
                      
                      // hoverable
                      style={{
                        borderRadius: '24px',
                        cursor: 'pointer',
                        border: selectedCard?.id === oneGame.id ? '4px solid rgb(255, 149, 0)' : "4px solid transparent",
                      }}
                    >
                      <Row gutter={(screens.xs || isTablet) ? 12 : 16} justify="space-between" align="middle">
                        <Col
  span={(screens.xs || isTablet) ? 16 : 18}
  style={{
    display: "flex",
    alignItems: "center",
    gap: (screens.xs || isTablet) ? 12 : 24,
  }}
>
  <StyledImageWrapper
    style={{
      height: (screens.xs || isTablet) ? 50 : 100,
      width: (screens.xs || isTablet) ? 50 : 100,
      borderRadius: "50%",
      overflow: "hidden",
      flexShrink: 0,
    }}
  >
    <Image
      preview={false}
      style={{ height: "100%", width: "100%", objectFit: "cover" }}
      src={oneGame.preview_image}
    />
  </StyledImageWrapper>

  <MyText
    color="rgba(19, 15, 38, 1)"
    size={(screens.xs || isTablet) ? 18 : 32}
    weight={800}
    style={{
      fontFamily: "Nunito",
      lineHeight: 1.2,
    }}
  >
    {oneGame.title}
  </MyText>
</Col>
                        <Row justify="space-between" align="middle">
                          <Row
  justify="center"
  align="middle"
  style={{
    background: 'rgb(255, 149, 0)',
    borderRadius: '50%',
    width: (screens.xs || isTablet) ? 30 : 60,
    height: (screens.xs || isTablet) ? 30 : 60,
    cursor: 'pointer',
  }}
  onClick={() => {
  if (selectedCard?.id === oneGame.id) {
    togglePlay();
  } else {
    selectCard(oneGame);
    setPlaying(true);
  }
}}
>
  {selectedCard?.id === oneGame.id && playing ? (
                          <PauseOutlined
                            style={{
                              color: "#fff",
                              fontSize: (screens.xs || isTablet) ? 20 :  44,
                              transform: "scaleX(1.3)"
                            }}
                          />
                        ) : (
                          <CaretRightOutlined
                            style={{
                              color: "#fff",
                              fontSize: (screens.xs || isTablet) ? 30 : 44,
                              marginLeft: 5,
                              transform: "scaleX(1.3)",
                            }}
                          />
                        )}
</Row>
                            </Row>
                             {token && (
                              isLikedForList(oneGame) ? (
                                            <HeartFilled
                                              style={{
                                                fontSize: "32px",
                                                color: "rgba(253, 99, 99, 1)",
                                                cursor: "pointer",
                                                height: '24px'
                                              }}
                                              onClick={token ? () => toggleLike(oneGame.id) : undefined}
                                            />
                                          ) : (
                                            <HeartOutlined
                                              style={{
                                                fontSize: "32px",
                                                color: "rgba(104, 114, 125, 1)",
                                                cursor: "pointer",
                                                height: '24px'
                                              }}
                                              onClick={token ? () => toggleLike(oneGame.id) : undefined}
                                            />
                                          ))}
                      </Row>
                    </Card>
                  </Col>

                  </>
                ))
              ) : (
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={24}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block' }}
                >
                  {t("noFound")}
                </MyText>
              )}

              {(screens.xs || isTablet) && (

 <Col
                    // key={oneGame.id + "-game-category"}
                    span={24}
                    // onClick={() => setSelectedCard(oneGame)}
                  >
                  <Card
    bordered
    style={{
      borderRadius: "24px",
      cursor: "pointer",
      background: `linear-gradient(
        to right,
        rgb(255, 227, 181) ${progress}%,
        #fff ${progress}%
      )`,
      transition: "background 0.2s ease",
      position: "fixed",
      bottom: 12,
      left: "50%",
      transform: "translateX(-50%)",
      width: (screens.xs || isTablet) ? "90%" : "600px",
      zIndex: 1000,
    }}
    onClick={handleCardClick}
  >
                      <Row gutter={(screens.xs || isTablet) ? 12 : 16} justify="space-between" align="middle">
                        <Col
  span={(screens.xs || isTablet) ? 17 : 18}
  style={{
    display: "flex",
    alignItems: "center",
    gap: (screens.xs || isTablet) ? 12 : 24,
  }}
>
  {/* <StyledImageWrapper
    style={{
      height: (screens.xs || isTablet) ? 50 : 100,
      width: (screens.xs || isTablet) ? 50 : 100,
      borderRadius: "50%",
      overflow: "hidden",
      flexShrink: 0,
    }}
  >
    <Image
      preview={false}
      style={{ height: "100%", width: "100%", objectFit: "cover" }}
      src={selectedCard?.preview_image}
    />
  </StyledImageWrapper> */}

  <MyText
    color="rgba(19, 15, 38, 1)"
    size={(screens.xs || isTablet) ? 18 : 32}
    weight={800}
    style={{
      fontFamily: "Nunito",
      lineHeight: 1.2,
    }}
  >
    {selectedCard?.title}
  </MyText>
</Col>
{talesListState?.data?.cards?.length > 1 &&
 selectedCard &&
 (talesListState?.data?.cards?.findIndex((c: any) => c.id === selectedCard.id) > 0) && (
  <Row
    justify="center"
    align="middle"
    style={{
      background: 'rgb(255, 149, 0)',
      borderRadius: '50%',
      width: (screens.xs || isTablet) ? 30 : 60,
      height: (screens.xs || isTablet) ? 30 : 60,
      cursor: 'pointer',
    }}
  >
    <BackwardOutlined
      style={{
        color: "#fff",
        fontSize: (screens.xs || isTablet) ? 20 : 44,
        transform: "scaleX(1.3)",
        cursor: "pointer",
      }}
      onClick={(e) => {
        e.stopPropagation();
        const cards = talesListState?.data?.cards || [];
        const currentIndex = cards.findIndex((c: any) => c.id === selectedCard.id);
        if (currentIndex > 0) {
          setSelectedCard(cards[currentIndex - 1]);
        }
      }}
    />
  </Row>
)}
                        <Row justify="space-between" align="middle">


                          <Row
  justify="center"
  align="middle"
  style={{
    background: 'rgb(255, 149, 0)',
    borderRadius: '50%',
    width: (screens.xs || isTablet) ? 30 : 60,
    height: (screens.xs || isTablet) ? 30 : 60,
    cursor: 'pointer',
  }}
   onClick={(e) => {
        e.stopPropagation();
        togglePlay();
      }}
>
  {playing ? (
                          <PauseOutlined
                            style={{
                              color: "#fff",
                              fontSize: (screens.xs || isTablet) ? 20 :  44,
                              transform: "scaleX(1.3)"
                            }}
                          />
                        ) : (
                          <CaretRightOutlined
                            style={{
                              color: "#fff",
                              fontSize: (screens.xs || isTablet) ? 30 : 44,
                              marginLeft: 5,
                              transform: "scaleX(1.3)",
                            }}
                          />
                        )}
</Row>
                            </Row>
                             <Row
                          justify="center"
                          align="middle"
                          style={{
                            background: 'rgb(255, 149, 0)',
                            borderRadius: '50%',
                            width: (screens.xs || isTablet) ? 30 : 60,
                            height: (screens.xs || isTablet) ? 30 : 60,
                            cursor: 'pointer',
                          }}
                        >
                                                  <ForwardOutlined
                                      style={{
                                        color: "#fff",
                                        fontSize: (screens.xs || isTablet) ? 20 : 44,
                                        transform: "scaleX(1.3)",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (!selectedCard) return;
                                        const cards = talesListState?.data?.cards || [];
                                        const currentIndex = cards.findIndex((c: any) => c.id === selectedCard.id);
                                        if (currentIndex !== -1 && cards.length > 0) {
                                          const nextIndex = (currentIndex + 1) % cards.length; 
                                          setSelectedCard(cards[nextIndex]);
                                        }
                                      }}
                                    />
                        </Row>
                      </Row>
                    </Card>
                  </Col>

              )
              }
            </Row>
          </Spin>
        </Card>
        </Col>     
          
                      <audio
                      ref={audioRef}
                      src={selectedCard?.audio_link}
                      onLoadedMetadata={(e) => {
                        const duration = e.currentTarget.duration;
                        setRemaining(duration);
                      }}
                      onTimeUpdate={handleTimeUpdate}
                      onEnded={() => setPlaying(false)}
                    />
          {talesListState?.data?.cards?.length && !(screens.xs || isTablet) ? (
                <Col
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                  <Card style={{borderRadius: '20px'}}>
                    <Spin spinning={talesListState?.loading}>
                    <Row justify="center" style={{height: screens.xs ? 'auto' : '400px'}}>
                        <StyledImageWrapper>
                  <Image
                    preview={false}
                    style={{height: '100%', width: '100%'}}
                    src={selectedCard?.preview_image}
                  />
                </StyledImageWrapper>
                      </Row>
                      <Col style={{ marginTop: 36, display: 'flex', justifyContent: 'center'}}>
                        <MyText
                          color="rgba(19, 15, 38, 1)"
                          size={42}
                          weight={800}
                          style={{ fontFamily: 'Nunito', display: 'block' }}
                        >
                          {selectedCard?.title}
                        </MyText>
                      </Col>

                      <Row align="middle" style={{ marginBottom: 26, gap: 16 }}>

                      <Slider
                        style={{ flex: 1 }}
                        value={progress}
                        onChange={handleSliderChange}
                        trackStyle={{ backgroundColor: "rgb(255, 149, 0)", height: 12, borderRadius: 24 }}
                        railStyle={{ backgroundColor: "#ffe3b5", height: 12, borderRadius: 24 }}
                        handleStyle={{ display: "none" }}
                      />

                      {/* <audio
                      ref={audioRef}
                      src={selectedCard?.audio_link}
                      onLoadedMetadata={(e) => {
                        const duration = e.currentTarget.duration;
                        setRemaining(duration);
                      }}
                      onTimeUpdate={handleTimeUpdate}
                      onEnded={() => setPlaying(false)}
                    /> */}
                    </Row>
                      <Row justify="space-between" align="middle">
                      <Row
                        justify="center"
                        align="middle"
                        style={{
                          background: "rgb(255, 149, 0)",
                          borderRadius: 24,
                          width: 60,
                          height: 60,
                          cursor: "pointer",
                        }}
                        onClick={togglePlay}
                      >
                        {playing ? (
                          <PauseOutlined
                            style={{
                              color: "#fff",
                              fontSize: 32,
                              transform: "scaleX(1.3)"
                            }}
                          />
                        ) : (
                          <CaretRightOutlined
                            style={{
                              color: "#fff",
                              fontSize: 44,
                              marginLeft: 5,
                              transform: "scaleX(1.3)",
                            }}
                          />
                        )}
                      </Row>

                      <Row align="middle" gutter={[12,12]}>
                      <Col>
                      <MyText
                        color="#4C4C4D"
                        size={24}
                        weight={700}
                        style={{ fontFamily: "Nunito", display: "block" }}
                      >
                      {formatTime(remaining)}
                      </MyText>
                      </Col>
                      <Col>
                      <Row>
                           {token && (
                            selectedIsLiked && selectedCard ? (
                                            <HeartFilled
                                              style={{
                                                fontSize: "32px",
                                                color: "rgba(253, 99, 99, 1)",
                                                cursor: "pointer",
                                                height: '24px'
                                              }}
                                              onClick={token ? () => toggleLike(selectedCard.id) : undefined}
                                            />
                                          ) : (
                                            <HeartOutlined
                                              style={{
                                                fontSize: "32px",
                                                color: "rgba(104, 114, 125, 1)",
                                                cursor: "pointer",
                                                height: '24px'
                                              }}
                                              onClick={token ? () => toggleLike(selectedCard.id) : undefined}
                                            />
                                          ))}
                            </Row>
                          </Col>
                          </Row>

                        </Row>
                        </Spin>
                  </Card>

                </Col>
          ) : (
            <>
            </>
          )}
              
            </Row>
        </Col>
          
                          </Row>

      </Col>

      
    </Row>
        </Row>
  </>

  )
}